import Swiper from 'swiper';
import { Navigation, Thumbs, A11y, EffectFade } from 'swiper/modules';

export function initGalleryModal() {
    const galleries = document.querySelectorAll('.js-box-gallery');
    if (!galleries.length) return;

    galleries.forEach((gallery) => {
        if (!(gallery instanceof HTMLElement)) return;

        const triggers = gallery.querySelectorAll('.js-trigger-gallery');
        if (!triggers.length) return;

        let modal: HTMLElement | null = null;
        let mainSwiper: Swiper | null = null;
        let previewSwiper: Swiper | null = null;
        let currentActiveIndex = 0; // ← запоминаем, какой слайд нужно показать

        triggers.forEach((trigger, index) => {
            trigger.addEventListener('click', (e) => {
                e.preventDefault();

                console.log('Clicked index:', index);
                currentActiveIndex = index;

                // --- CREATE MODAL (ONLY ONCE) ---
                if (!modal) {
                    modal = createModal(gallery);
                    document.body.appendChild(modal);

                    const mainEl = modal.querySelector('.swiper-detail-card');
                    const previewEl = modal.querySelector('.swiper-preview-card');
                    const prevBtn = modal.querySelector('.--prev');
                    const nextBtn = modal.querySelector('.--next');

                    if (!(mainEl instanceof HTMLElement) || !(previewEl instanceof HTMLElement)) return;

                    // --- PREVIEW (Thumbs) ---
                    previewSwiper = new Swiper(previewEl, {
                        modules: [ Thumbs, A11y],
                        slidesPerView: 4,
                        spaceBetween: 8,
                        watchSlidesProgress: true,
                        slideToClickedSlide: true,
                        breakpoints: {
                            992: {
                                slidesPerView: 7,
                                spaceBetween: 12,
                            },
                        },
                    });

                    // --- MAIN ---
                    mainSwiper = new Swiper(mainEl, {
                        modules: [Navigation, Thumbs, A11y, EffectFade],
                        slidesPerView: 1,
                        spaceBetween: 10,
                        observer: true,
                        observeParents: true,
                        speed: 600,
                        effect: 'fade',
                        fadeEffect: { crossFade: true },
                        thumbs: { swiper: previewSwiper },
                        navigation: {
                            prevEl: prevBtn,
                            nextEl: nextBtn,
                        },
                    });

                    function closeModal() {
                        modal?.classList.remove('active');
                    }

                    // --- CLOSE LOGIC ---
                    modal.addEventListener('click', (e) => {
                        const target = e.target as HTMLElement;
                        if (target.classList.contains('modal-gallery') || target.classList.contains('modal-gallery-close')) {
                            closeModal()
                        }
                    });

                    // --- ЗАКРЫТИЕ ПО ESC ---
                    document.addEventListener('keydown', (e) => {
                        if (e.key === 'Escape' && modal?.classList.contains('active')) {
                            closeModal();
                        }
                    });
                }

                
                // --- OPEN MODAL ---
                modal?.classList.add('active');

                // --- UPDATE SWIPER SLIDE INDEX BEFORE OPENING ---
                requestAnimationFrame(() => {
                    mainSwiper?.update();
                    previewSwiper?.update();

                    mainSwiper?.slideTo(currentActiveIndex, 0);
                    previewSwiper?.slideTo(currentActiveIndex, 0);
                });

            });
        });
    });
}

// =======================
// CREATE MODAL FUNCTION (без изменений)
// =======================
function createModal(sourceGallery: HTMLElement): HTMLElement {
    const modal = document.createElement('div');
    modal.className = 'modal-gallery';

    const content = document.createElement('div');
    content.className = 'modal-gallery__content';

    const closeBtn = document.createElement('button');
    closeBtn.className = 'modal-gallery__close modal__close modal-gallery-close';
    closeBtn.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
            <path d="M9.33398 9.33331L22.6673 22.6666M9.33398 22.6666L22.6673 9.33331" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>`
    ;

    // --- CLONE ---
    const clone = sourceGallery.cloneNode(true) as HTMLElement;

    clone.classList.remove('js-box-gallery');
    clone.querySelectorAll('.js-trigger-gallery').forEach(el => {
        el.classList.remove('js-trigger-gallery');
    });

    content.appendChild(closeBtn);
    content.appendChild(clone);
    modal.appendChild(content);

    return modal;
}
